import { render, staticRenderFns } from "./OccupationRank.vue?vue&type=template&id=722624e2&scoped=true"
import script from "./OccupationRank.vue?vue&type=script&lang=js"
export * from "./OccupationRank.vue?vue&type=script&lang=js"
import style0 from "./OccupationRank.vue?vue&type=style&index=0&id=722624e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722624e2",
  null
  
)

export default component.exports